export const Vendorendpoint = {
    getVendorsDetails: `/admin/getVendorLists`,
    updateActivationStatus:`/admin/common/update-vendor/`
  };
  